<template>
  <div>
    <navbar :hasSearch="false" />
    <!-- Page Content Holder -->
    <div id="content">
      <div class="landing_page_navigation">
        <div class="row">
          <div class="col-md-6 pb-3">
            <div class="card h-100">
              <ol class="breadcrumb my-auto">
                <li class="breadcrumb-item active font-weight-bold pl-3">
                  <a class="black-text" href="#">Home</a>
                  <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
                </li>
              </ol>
            </div>
          </div>
          <quick-links></quick-links>
        </div>
      </div>
      <div class="landing_page_body">
        <div class="container-fluid">
          <div class="row search_head">
            <div class="col-md-4 text-center">
              <div class="bee">
                <img src="https://media.giphy.com/media/50StK52WhMzxC/giphy.gif" alt="Bee">
              </div>
            </div>
            <div class="col-sm-6 col-md-4 text-center my-auto">
              <h1>Honeycomb</h1>
            </div>
            <div class="col-sm-6 col-md-4 text-center mobile-space my-auto">
              <p class="d-inline">Powered by:</p>
              <img src="@/assets/img/redbear_logo.png" class="img-fluid pl-2" alt="Redbear Logo">
            </div>
          </div>
          <div class="row">
            <div class="col-sm mt-4">
              <div class="input-group w-xl-80 mx-auto mt-4">
                <input v-model="searchId" @keyup="search" class="form-control form-control-lg" type="text"
                  placeholder="Search" aria-label="Search">
                <div class="input-group-append">
                  <span class="input-group-text amber lighten-3" id="basic-text1">
                    <i class="fa fa-search text-grey" aria-hidden="true"></i>
                    <!-- <router-link :to="{ name: 'dashboard'}"></router-link> -->
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- THIS IS WHEN WE ADD FACT OF THE DAY BACK IN -->
          <!-- <div class="row">
            <div class="col-xl-8 offset-xl-2 mt-5 text-center">
              <h3 class="pb-3">Interesting fact of the day........</h3>
              <p class="pb-5">Snakes can help predict earthquakes. They can sense a coming earthquake from 75 miles
                away, up to five days before it happens.</p>
                <div v-if="results && results.SearchResult">
                <ul v-for="(result, index) in results.SearchResult" :key="index">
                  <li @click="setCustomer(result.Customer)">
                    {{result.Customer.CustomerName + ' - ' + result.Customer.CustomerReference}}
                  </li>
                </ul>
                </div>
                <p>{{results}}</p>
            </div>
          </div> -->
          <!-- THIS IS TO BE DISPLAYED IF NO SEARCH RESULTS FOUND -->
          <div v-if="(results && (results == 0 || !results)) && searchId.length > 0" class="row">
            <div class="col-sm">
              <div class="w-xl-80 mx-auto mt-4">
                <h5>Search Results:</h5>
                <p class="d-inline">Sorry, no results found just yet......</p>
              </div>
            </div>
          </div>

          <div v-else-if="results && results.length >= 1 && searchId.length > 2" class="row">
            <div class="col-sm">
              <div class="w-xl-80 mx-auto mt-1">
                <template>
                  <div class="table-responsive-lg pre-scrollable">
                    <b-table class="callout" @row-clicked="setCustomer" responsive hover outlined striped
                      :items="results" :fields="searchResultFields">
                      <template slot="ref" slot-scope="data">
                        {{data.item.ref}}
                      </template>
                      <template slot="name" slot-scope="data">
                        {{data.item.name}}
                      </template>
                      <template slot="address" slot-scope="data">
                        {{data.item.address}}
                      </template>
                      <template slot="status" slot-scope="data">
                        <b-badge v-if="data.item.Document.IsBillable" class="pill my-auto" variant="success">
                          Active</b-badge>
                        <b-badge v-else class="pill my-auto" variant="secondary">Inactive</b-badge>
                      </template>
                    </b-table>
                  </div>
                </template>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <!-- content close -->
  </div>
  <!-- sidebar_content close -->
</template>

<script>
  import Navbar from '@/components/Navbar.vue';
  import QuickLinks from '@/components/QuickLinks.vue'
  var base64js = require('base64-js')

  export default {
    components: {
      Navbar,
      QuickLinks
    },
    data() {
      return {
        searchId: '',
        searchResultFields: {
          ref: {
            key: 'Document.CustomerReference',
            label: 'Customer Reference',
            sortable: true,
            'class': 'text-center'
          },
          name: {
            key: 'Document.CustomerName',
            label: 'Customer Name',
            sortable: true,
            'class': 'text-center'
          },
          address: {
            key: 'Document.Addresses[0]',
            label: 'Customer Address',
            'class': 'text-center'
          },
          status: {
            label: 'Status',
            'class': 'text-center'
          },
        },
      }
    },
    computed: {
      results() {
        return this.$store.state.results;
      },
      perm() {
        return base64js.toByteArray(this.$auth.decodedToken.payload.perm)
      }
    },
    methods: {
      binaryString(index) {
        return this.perm[index].toString(2).padStart(8, 0)
      },
      search: function () {
        this.$store.dispatch('search', this.searchId);
      },
      setCustomer: function (result) {
        // this.$store.dispatch('setCustomer', result.Document.CustomerReference);
        this.searchId = '';
        this.$store.commit('resetResults');
        this.$router.push("/dashboard/" + result.Document.CustomerReference);
      },

    },
    created() {
      this.$store.commit('resetResults');
      this.$store.dispatch('updateReleaseVersions')
      if (this.$store.state.permissionAreas == null) {
        this.$store.dispatch('getPermissionAreas')
      }
    }
  }
</script>